const PRIMER3_PARAMS = {
  saltMonovalent: 50,
  // mM
  saltDivalent: 1.5,
  // mM
  dntpConc: 0.6,
  // mM
  dnaConc: 50,
  // nM
  R: 1.987
  // Gas constant (cal/K·mol)
};
export const SANTA_LUCIA_NN = {
  AA: { dH: -7.9, dS: -22.2 },
  TT: { dH: -7.9, dS: -22.2 },
  AT: { dH: -7.2, dS: -20.4 },
  TA: { dH: -7.2, dS: -21.3 },
  CA: { dH: -8.5, dS: -22.7 },
  TG: { dH: -8.5, dS: -22.7 },
  GT: { dH: -8.4, dS: -22.4 },
  AC: { dH: -8.4, dS: -22.4 },
  CT: { dH: -7.8, dS: -21 },
  AG: { dH: -7.8, dS: -21 },
  GA: { dH: -8.2, dS: -22.2 },
  TC: { dH: -8.2, dS: -22.2 },
  CG: { dH: -10.6, dS: -27.2 },
  GC: { dH: -9.8, dS: -24.4 },
  GG: { dH: -8, dS: -19.9 },
  CC: { dH: -8, dS: -19.9 }
};
export const SANTA_LUCIA_INIT = {
  GC: { dH: 0.1, dS: -2.8 },
  // initiation with terminal GC
  AT: { dH: 2.3, dS: 4.1 }
  // initiation with terminal AT
};
function getEffectiveMonovalentConc() {
  let effectiveMono = PRIMER3_PARAMS.saltMonovalent;
  if (PRIMER3_PARAMS.saltDivalent > 0) {
    const freeMg = Math.max(
      0,
      PRIMER3_PARAMS.saltDivalent - PRIMER3_PARAMS.dntpConc
    );
    effectiveMono += 120 * Math.sqrt(freeMg);
  }
  return effectiveMono;
}
function applySaltCorrection(deltaS, nnPairs) {
  const effectiveMono = getEffectiveMonovalentConc();
  return deltaS + 0.368 * nnPairs * Math.log(effectiveMono / 1e3);
}
export function isValidSequence(sequence) {
  return /^[ATGCN]+$/.test(sequence);
}
export default function calculateSantaLuciaTm(sequence) {
  try {
    sequence = sequence?.toUpperCase().trim();
    if (!isValidSequence(sequence)) {
      throw new Error("Invalid sequence: contains non-DNA characters");
    }
    if (sequence.length < 2) {
      throw new Error("Sequence too short: minimum length is 2 bases");
    }
    let deltaH = 0;
    let deltaS = 0;
    for (let i = 0; i < sequence.length - 1; i++) {
      const dinucleotide = sequence.substring(i, i + 2);
      if (dinucleotide.includes("N")) {
        continue;
      }
      const params = SANTA_LUCIA_NN[dinucleotide];
      if (params) {
        deltaH += params.dH;
        deltaS += params.dS;
      }
    }
    const firstBase = sequence[0];
    const lastBase = sequence[sequence.length - 1];
    if (firstBase === "G" || firstBase === "C") {
      deltaH += SANTA_LUCIA_INIT.GC.dH;
      deltaS += SANTA_LUCIA_INIT.GC.dS;
    } else {
      deltaH += SANTA_LUCIA_INIT.AT.dH;
      deltaS += SANTA_LUCIA_INIT.AT.dS;
    }
    if (lastBase === "G" || lastBase === "C") {
      deltaH += SANTA_LUCIA_INIT.GC.dH;
      deltaS += SANTA_LUCIA_INIT.GC.dS;
    } else {
      deltaH += SANTA_LUCIA_INIT.AT.dH;
      deltaS += SANTA_LUCIA_INIT.AT.dS;
    }
    const nnPairs = sequence.length - 1;
    deltaS = applySaltCorrection(deltaS, nnPairs);
    const C = PRIMER3_PARAMS.dnaConc * 1e-9;
    const Tm = deltaH * 1e3 / (deltaS + PRIMER3_PARAMS.R * Math.log(C / 4));
    return Tm - 273.15;
  } catch (e) {
    return `Error calculating Tm for sequence ${sequence}. ${e}`;
  }
}
